import './DataTable.scss';
import {
  ComboBox,
  DataTable,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  DataTableCustomRenderProps,
  Pagination,
  TableToolbar,
  TableToolbarContent,
  TableContainer,
} from 'carbon-components-react';
import { useEffect, useState } from 'react';
import { AppConfiguration } from '../../lib/type';

const DataTableComponent: React.FC<AppConfiguration> = ({
  description,
  groups,
  legends,
}) => {
  const [firstRowIndex, setFirstRowIndex] = useState(0);
  const [currentPageSize, setCurrentPagesize] = useState(10);
  const [selectedRegion, setSelectedRegion] = useState('');

  const doHeader = () => {
    const header = [];
    header.push({ key: 'country', header: 'Location' });
    legends.forEach((element: { title: string; type: string }) => {
      const noSpecialCharacter = element.type.replaceAll('-', '');
      header.push({ key: noSpecialCharacter, header: element.title });
    });

    return header;
  };

  const doRows = () => {
    const row: {
      id: string;
      country: string;
      datacenters: string;
      federaldatacenter: string;
      multizone: string;
      networkpop: string;
    }[] = [];
    groups.forEach((element) => {
      const region = element.region;
      if (region.includes(selectedRegion)) {
        row.push({
          id: (Math.random() + 1).toString(36).substring(7),
          country: element.city,
          datacenters: element.types.includes('data-centers') ? '✓' : '',
          federaldatacenter: element.types.includes('federal-data-center')
            ? '✓'
            : '',
          multizone: element.types.includes('multi-zone') ? '✓' : '',
          networkpop: element.types.includes('network-pop') ? '✓' : '',
        });
      } else if (selectedRegion.length <= 0) {
        row.push({
          id: (Math.random() + 1).toString(36).substring(7),
          country: element.city,
          datacenters: element.types.includes('data-centers') ? '✓' : '',
          federaldatacenter: element.types.includes('federal-data-center')
            ? '✓'
            : '',
          multizone: element.types.includes('multi-zone') ? '✓' : '',
          networkpop: element.types.includes('network-pop') ? '✓' : '',
        });
      }
    });

    return row;
  };

  const rows = doRows();
  const headers = doHeader();

  const initiateLegends = () => {
    setSelectedRegion('');
  };

  const updateLegendSelection = (e: any) => {
    if (e.selectedItem != null) {
      setSelectedRegion(e.selectedItem.text);
    } else {
      setSelectedRegion('');
    }
  };
  const items = [
    {
      id: 'america',
      text: 'Americas',
    },
    {
      id: 'emea',
      text: 'EMEA',
    },
    {
      id: 'apac',
      text: 'APAC',
    },
  ];
  // Initiate Everything
  useEffect(() => {
    initiateLegends();
  }, []);

  return (
    <div className="wm-data-table">
      <DataTable
        size="xs"
        rows={rows.slice(firstRowIndex, firstRowIndex + currentPageSize)}
        headers={headers}
      >
        {({
          rows,
          headers,
          getTableProps,
          getHeaderProps,
          getRowProps,
          getTableContainerProps,
          getToolbarProps,
        }: DataTableCustomRenderProps) => (
          <TableContainer
            title={description.title}
            {...getTableContainerProps()}
          >
            <TableToolbar
              aria-label="data table toolbar"
              {...getToolbarProps()}
              className="toolbar-container"
            >
              <span className="bx--table-placholder-label">
                {description.filterLabel}
              </span>
              <TableToolbarContent>
                <ComboBox
                  id="carbon-combobox"
                  size="sm"
                  onChange={(e) => updateLegendSelection(e)}
                  items={items}
                  itemToString={(item) => (item ? item.text : '')}
                  placeholder={''}
                />
              </TableToolbarContent>
            </TableToolbar>
            <Table {...getTableProps()}>
              <TableHead className="header-bakground">
                <TableRow>
                  {headers.map((header) => (
                    <TableHeader {...getHeaderProps({ header })}>
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow {...getRowProps({ row })}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>{cell.value}</TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DataTable>
      <Pagination
        backwardText={description.previousPage}
        forwardText={description.nextPage}
        itemsPerPageText=""
        onChange={({ page, pageSize }) => {
          if (pageSize !== currentPageSize) {
            setCurrentPagesize(pageSize);
          }
          setFirstRowIndex(pageSize * (page - 1));
        }}
        pageSize={currentPageSize}
        pageSizes={[10, 20, 33]}
        size="md"
        totalItems={rows.length}
      />
    </div>
  );
};

export default DataTableComponent;
